import client from '@/api/client.js';
import store from "@/store";
export default {
    methods: {
        async getSettingsGroup(groups) {
            var meta = { clientApiMethod: 'getSettingsGroup', input: { query: groups } }
            var response = await client().get(store.state.apiRouteRoot + "settings/group", { params: groups, meta: meta })
            return response?.data;
        },
        async setSettingsGroup(groups) {
            var meta = { clientApiMethod: 'setSettingsGroup', input: { query: groups } }
            var response = await client().post(store.state.apiRouteRoot + "settings/group", groups, { meta: meta })
            return response?.data;
        },
        async getSettingsListByGroup(groups) {
            var meta = { clientApiMethod: 'getSettingsListByGroup', input: { query: groups } }
            var response = await client().get(store.state.apiRouteRoot + "settings/list", { params: groups, meta: meta })
            return response?.data;
        },
        async setSettingsList(settings) {
            var meta = { clientApiMethod: 'setSettingsList', input: { query: settings } }
            var response = await client().post(store.state.apiRouteRoot + "settings/list", settings, { meta: meta })
            return response?.data;
        },
        async getBooleanSettingByName(settingName) {
            var meta = { clientApiMethod: 'getBooleanSettingByName', input: { settingId: settingName } }
            var response = await client().get(store.state.apiRouteRoot + "settings/settingName/" + settingName, { meta: meta })
            return response?.data.toLowerCase() === 'true';
        },
        async getSettingByName(settingName) {
            var meta = { clientApiMethod: 'getSettingByName', input: { settingId: settingName } }
            var response = await client().get(store.state.apiRouteRoot + "settings/settingName/" + settingName, { meta: meta })
            return response?.data;
        },
        async setSetting(setting) {
            var meta = { clientApiMethod: 'setSetting', input: { setting } }
            var response = await client().post(store.state.apiRouteRoot + "settings", setting, { meta: meta })
            return response?.data;
        },

        async setSiteLogo(image) {
            let formData = new FormData();
            if (image) {
                formData.append("imageFile", image, image.name);
            }
            var meta = { clientApiMethod: 'setSiteLogo', input: {} }
            var response = await client().post(store.state.apiRouteRoot + "settings/UpdateLogo", formData, {
                headers: { "Content-Type": "multipart/form-data" },
                transformRequest: formData => formData,
                meta: meta
            })
            return response?.data;
        },

        async getERPIntegrationSettings() {
            var meta = { clientApiMethod: 'getERPIntegrationSettings', input: {} }
            var response = await client().get(store.state.apiRouteRoot + "Settings/CurrentErpConfiguration", { meta: meta })
            return response?.data;
        },


        async getQAISettings() {
            var meta = { clientApiMethod: 'getQAISettings', input: {} }
            var response = await client().get(store.state.apiRouteRoot + "Settings/CurrentAIConfiguration", { meta: meta })
            return response?.data;
        },


        async saveERPIntegrationSettings(payload) {
            var meta = { clientApiMethod: 'saveERPIntegrationSettings', input: { payload } }
            var response = await client().post(store.state.apiRouteRoot + "Settings/UpdateErpConfiguration", payload, { meta: meta })
            return response?.data;
        },

        async saveQAISettings(payload) {
            var meta = { clientApiMethod: 'saveQAISettings', input: { payload } }
            var response = await client().post(store.state.apiRouteRoot + "Settings/UpdateAIConfiguration", payload, { meta: meta })
            return response?.data;
        },

        async getErpExportPlugins() {
            var meta = { clientApiMethod: 'getErpExportPlugins', input: {} }
            var response = await client().get(store.state.apiRouteRoot + "Settings/ErpExportPlugins", { meta: meta })
            return response?.data;
        },
    }
}